import { render } from "./IdleDevicesTable.vue?vue&type=template&id=3d7635c4&scoped=true&ts=true&lang=pug"
import script from "./IdleDevicesTable.vue?vue&type=script&lang=ts"
export * from "./IdleDevicesTable.vue?vue&type=script&lang=ts"

import "./IdleDevicesTable.vue?vue&type=style&index=0&id=3d7635c4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7635c4"]])

export default __exports__